// @ts-nocheck
import { toDateInputValue } from "../../../helpers/general";
import { ALL_DAYS } from "../../../helpers/constants";
import type {
  ApiDayHours,
  ApiOpeningHours,
  CleanedOpeningHours,
  DayFormValue,
  DayStatus,
  ExceptionFormValue,
  OpeningHoursFormValues,
  WeekDay,
} from "../../../helpers/types";

export const getDayHoursType = (day: ApiDayHours): DayStatus => {
  if (day.closed) return "closed";
  if (day.openAllDay) return "openAllDay";
  return "custom";
};

/** API shape -> form shape (one day) */
export const transformToFormValue = (day: ApiDayHours): DayFormValue => {
  const status = getDayHoursType(day);
  return status === "custom"
    ? { status, ranges: day.ranges ?? [] }
    : { status };
};

export const formatExceptionDates = (
  exceptions: ExceptionFormValue[],
): ExceptionFormValue[] =>
  exceptions.map((e) => ({ ...e, date: toDateInputValue(e.date) }));

/** API response -> values ready to be pushed into the form */
export const parseOpeningHoursResponse = (resp: ApiOpeningHours) => {
  const days: Partial<Record<WeekDay, DayFormValue>> = {};
  ALL_DAYS.forEach((day) => {
    const value = resp?.[day];
    if (value) days[day] = transformToFormValue(value);
  });
  return {
    days,
    exceptions: resp?.exceptions
      ? formatExceptionDates(resp.exceptions)
      : undefined,
  };
};

const cleanDay = ({ status, ranges = [] }: DayFormValue): ApiDayHours => {
  if (status === "custom") {
    return { ranges: ranges.filter((r) => r.from !== "" && r.to !== "") };
  }
  if (status === "openAllDay") return { openAllDay: true };
  return { closed: true };
};

/** Form shape -> payload sent to the API */
export const cleanOpeningHoursData = (
  data: OpeningHoursFormValues,
): CleanedOpeningHours => {
  const cleaned = {
    exceptions: data.exceptions ?? [],
    ...Object.fromEntries(ALL_DAYS.map((d) => [d, {}])),
  } as CleanedOpeningHours;

  ALL_DAYS.forEach((day) => {
    const value = data[day];
    if (value) cleaned[day] = cleanDay(value);
  });
  return cleaned;
};

/** Deep copy so copied days don't share references */
export const cloneDayValue = (value: DayFormValue): DayFormValue => ({
  ...value,
  ranges: value.ranges?.map((r) => ({ ...r })),
});